<template>
  <PopoverMenu trigger="hover" placement="right-end" :auto-hide="false" data-test-id="menu-user">
    <template #trigger>
      <div class="navbar-user-menu__button" data-test-id="menu-user-opener" :data-test-user-name="user.fullname">
        <UserAvatar :image="user.image" :firstname="user.firstname" :lastname="user.lastname" size="big" />
        <span class="navbar-user-menu__title">{{ user.fullname }}</span>
      </div>
    </template>

    <template #items-list>
      <PopoverMenuSection>
        <PopoverMenuItem
          data-test-id="navbar-menu-user"
          :primary-text="$t('action.account')"
          :href="acoHost"
          target="'_blank'"
        />
        <PopoverMenuItem :primary-text="$t('userSettings.title')" :to="{ name: 'usersettings' }" />
        <PopoverMenuItem
          :primary-text="$t('action.logout')"
          @click="logout"
          data-test-id="navbar-menu-user-logout-button"
        />
      </PopoverMenuSection>
    </template>
  </PopoverMenu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UserMenu',

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      acoHost: `${this.$config.acoHost}/profile`,
    };
  },

  methods: {
    logout() {
      this.$store.dispatch('user/logout');
    },
  },
});
</script>
<style lang="scss">
@use 'settings/colors';
@use 'mixins/typography';
.navbar-user-menu__button {
  display: flex;
  align-items: center;
  container-type: inline-size;
  width: 100%;

  .user-avatar {
    flex-shrink: 0;
  }
}

.navbar-user-menu__title {
  margin-left: 0;
  display: none;
  color: colors.$color-black;

  @include typography.typography-ellipsis;
  line-height: 22px;
}

@container (inline-size > 40px) {
  .navbar-user-menu__title {
    margin-left: 12px;
    display: block;
  }
}
</style>
